<div class="offset-nonav center-content loginpage">

    <div class="container container-narrow">
        <div class="logoholder">
            <img src="../../images/BB-Link-logo.svg" class="img-responsive" />
        </div>

        <div>
            <h1>Unsupported browser</h1>
            <p>
                Internet Explorer is no longer supported by Link.
            </p>
        </div>
    </div>
</div>
